import { useSnackbar } from "notistack";
import Slide from "@mui/material/Slide";
import { useCallback } from "react";

export const useToastMessage = () => {
  const { enqueueSnackbar, closeSnackbar: closeToast } = useSnackbar();

  const [vertical, horizontal] = ["top", "center"];

  function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
  }

  const setToast = useCallback(
    (message) => {
      enqueueSnackbar(message, {
        autoHideDuration: 6000,
        anchorOrigin: { vertical, horizontal },
        TransitionComponent: TransitionDown,
        variant: "success",
      });
    },
    [enqueueSnackbar, horizontal, vertical]
  );

  const setWarningToast = (message) => {
    enqueueSnackbar(message, {
      autoHideDuration: 6000,
      anchorOrigin: { vertical, horizontal },
      TransitionComponent: TransitionDown,
      variant: "warning",
    });
  };

  return { setToast, setWarningToast, closeToast };
};
